// eslint-disable-next-line react/prop-types
const Commmon = ({ color, name }) => {
  return (
    <>
      <div className="text-xl md:text-3xl font-bold">
        <span style={{ color: color }}>{name} </span>
        SUPPORT FOR PATIENTS AND PROVIDERS
      </div>
    </>
  )
}

export default Commmon;